import { URLFiltersType } from 'Models/history/isURLFilters';

export default function hasAppliedFilters(filters?: URLFiltersType) {
	return filters ? Object.values(filters).some((val) => val) : false;
}
